//include 8
jQuery(function(){

    window.pixelpoint = window.pixelpoint || {};
    window.pixelpoint.ga = {
        disable: function(){
            if(!window.pixelpoint.utilities.isIframe()){
                document.cookie = disableStr + '=true; expires=Thu, 31 Dec 2099 23:59:59 UTC; path=/';
                //window[disableStr] = true;
            }
            else{
                window.parent.postMessage({
                    event_id:"deactivateAnalytics"
                },"*");
            }
        },
        enable: function(){
            window.eraseCookie(disableStr);
        }
    };

    $("body").on("click",".deactivate-google-analytics",function(e){
        e.preventDefault();
        window.pixelpoint.ga.disable();
        window.pixelpoint.modal.open("Sie haben Google Analytics erfolgreich deaktiviert");
    });
});